import { render } from "./Compass2.vue?vue&type=template&id=5941180b&scoped=true"
import script from "./Compass2.vue?vue&type=script&lang=js"
export * from "./Compass2.vue?vue&type=script&lang=js"

import "./Compass2.vue?vue&type=style&index=0&id=5941180b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5941180b"]])

export default __exports__